<template>
  <el-row class="home" :gutter="20">
    <el-col :span="8">
      <el-card shadow="hover">
        <div class="user">
          <img :src="userImg" />
          <div class="userinfo">
            <p class="name">您好：</p>
            <p class="access">{{ userinfo.mobile }}</p>
          </div>
        </div>
        <div class="login-info"></div>
      </el-card>
      <el-card shadow="hover" style="height: 350px; margin-top: 20px">
        <!-- <echart :chartData="echartData.user" style="height: 260px"></echart> -->
        <div class="block">
          <div>
            <span>[ 朗新 ]，语出《淮南子》“日开天霁，朗而新之” </span>
            <el-divider content-position="right"></el-divider>
            <span>其意是描绘宇宙形成、天地初开时一派清新、</span>
            <el-divider content-position="right"></el-divider>
            <span>隽朗的气象。朗新科技以龙的精神，不断突破，</span>
            <el-divider content-position="right"></el-divider>
            <span>勇于创新，聚焦产业互联网，创造产业新价值。</span>
            <el-divider content-position="right"></el-divider>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :span="16">
      <el-calendar>
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{ date, data }">
          <p :class="data.isSelected ? 'is-selected' : ''">
            {{
              data.day
                .split('-')
                .slice(1)
                .join('-')
            }}
            {{ data.isSelected ? '✔️' : '' }}
          </p>
        </template>
      </el-calendar>
    </el-col>
  </el-row>
</template>

<script>
//import Echart from '../../components/EChart'
import { userinfoLoginApi } from '../../api/getData'

export default {
  components: {
    //Echart
  },
  data() {
    return {
      userImg: require('../../assets/images/user.png'),
      countData: [],
      tableData: [],
      userinfo: {},
      tableLabel: {
        // name: 'XXX'
      },
      value: new Date(),
      echartData: {
        order: {
          xData: [],
          series: []
        },
        user: {
          xData: [],
          series: []
        },
        video: {
          series: []
        }
      }
    }
  },
  computed: {
    getToken() {
      return this.$store.state.token
    }
  },
  methods: {
    // getTableData() {
    //   this.$http.get('/home/getData').then(res => {
    //     res = res.data
    //     this.tableData = res.data.tableData
    // 订单折线图
    // const order = res.data.orderData
    // this.echartData.order.xData = order.date
    // // 第一步取出series中的name部分——键名
    // let keyArray = Object.keys(order.data[0])
    // // 第二步，循环添加数据
    // keyArray.forEach(key => {
    //   this.echartData.order.series.push({
    //     name: key === 'wechat' ? '小程序' : key,
    //     data: order.data.map(item => item[key]),
    //     type: 'line'
    //   })
    // })
    // 用户柱状图
    //     this.echartData.user.xData = res.data.userData.map(item => item.date)
    //     this.echartData.user.series.push({
    //       name: '新增用户',
    //       data: res.data.userData.map(item => item.new),
    //       type: 'bar'
    //     })
    //     this.echartData.user.series.push({
    //       name: '活跃用户',
    //       data: res.data.userData.map(item => item.active),
    //       type: 'bar',
    //       barGap: 0
    //     })
    //     // 视频饼图
    //     this.echartData.video.series.push({
    //       data: res.data.videoData,
    //       type: 'pie'
    //     })
    //   })
    // },

    //获取用户信息
    async getUserInfo() {
      try {
        const result = await userinfoLoginApi(this.getToken)
        if (result.data.code === 0) {
          this.userinfo = result.data.data
          this.$store.commit('setUsername', result.data.data.mobile)
          this.$store.commit('setCustomerId', result.data.data.customerId)
          this.$store.commit('setAccountType', result.data.data.accountType)
        }
      } catch (error) {
        console.log(error)
      }
    }
  },

  mounted() {
    //this.getTableData()
    this.getUserInfo()
    if (this.getToken) {
      this.getUserInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/home';
</style>

<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
